/**
 * Notification API Polyfill for Safari iOS
 * 
 * Safari on iOS doesn't support the Notification API at all.
 * This polyfill prevents crashes by providing a dummy implementation.
 */

// Check if Notification API is missing OR broken
if (typeof window !== 'undefined') {
  // Test if Notification exists and works
  let needsPolyfill = false;
  
  if (!('Notification' in window)) {
    console.log('[Notification Polyfill] Notification API missing - adding polyfill');
    needsPolyfill = true;
  } else {
    // Test if it's actually usable
    try {
      // Some browsers have Notification but it throws on construction
      const TestNotification = window.Notification;
      if (!TestNotification || typeof TestNotification !== 'function') {
        needsPolyfill = true;
      }
    } catch (e) {
      console.log('[Notification Polyfill] Notification API broken - adding polyfill');
      needsPolyfill = true;
    }
  }
  
  if (needsPolyfill) {
    // Create a proper dummy Notification constructor function (not class)
    const DummyNotification: any = function(this: any, title: string, options?: NotificationOptions) {
      // Allow use without 'new' keyword
      if (!(this instanceof DummyNotification)) {
        return new (DummyNotification as any)(title, options);
      }
      
      console.log('[Notification Polyfill] Notification created (not displayed):', title, options);
      
      // Set instance properties
      this.title = title;
      this.body = options?.body || '';
      this.icon = options?.icon || '';
      this.tag = options?.tag || '';
      this.onclick = null;
      this.onerror = null;
      this.onclose = null;
      this.onshow = null;
      
      // Auto-close after a moment
      setTimeout(() => {
        if (this.onclose) {
          this.onclose(new Event('close'));
        }
      }, 100);
    };
    
    // Add static properties
    DummyNotification.permission = 'denied';
    
    DummyNotification.requestPermission = function(): Promise<NotificationPermission> {
      console.log('[Notification Polyfill] requestPermission called - not supported on this device');
      return Promise.resolve('denied');
    };
    
    // Add prototype methods
    DummyNotification.prototype.close = function() {
      // no-op
    };
    
    // Add to window with proper descriptor to prevent "Illegal constructor" errors
    Object.defineProperty(window, 'Notification', {
      value: DummyNotification,
      writable: true,
      configurable: true,
      enumerable: true
    });
    
    console.log('[Notification Polyfill] Dummy Notification API installed successfully');
  }
}

export {};